<template>
	<div class="trainContainer">
		<img src="../assets/images/中心概括动物房.png" style="width: 100%;height: 100%;position: absolute;">
		<div style="position: absolute;width: 100%;height: 20rem;background-color: rgba(0, 0, 0, 0.4);z-index: 10;">
			
		</div>
		<div style="display: flex;flex-direction: column;align-items: center;z-index: 15;">
			<p style="font-size: 36px;color: #FFFFFF;margin: 0;margin: 0.3125rem 0;">{{title}}</p>
			<div style="width: 3.75rem;height: 0.375rem;background-color: #1890FF;"></div>
		</div>
		<a-input  v-model="searchValue" v-if="isSearch==true" class="searchBox" style="position: absolute;bottom: -0.9375rem;z-index: 15;" :placeholder="searchTitle?searchTitle:'请输入搜索值'">
			<a-tooltip slot="suffix">
				<a-icon @click="onSearch" type="search" style="color: #1890FF;cursor: pointer;" />
			</a-tooltip>
		</a-input>
	</div>
</template>

<script>
	export default{
		props:['title','isSearch','searchTitle'],
		data(){
			return{
				searchValue:''
			}
		},
		methods:{
			onSearch(){
				window.localStorage.setItem('searchValues',this.searchValue)
				if(this.$parent.getALLdata){
					this.$parent.getALLdata(100000)
				}
				if(this.$parent.getSelInstrument){
					this.$parent.queryPage.current = 1
					this.$parent.getSelInstrument({IsAccessControl:this.$parent.IsAccessControlVal,page:this.$parent.queryPage.current,row:this.$parent.queryPage.pageSize,name:window.localStorage.getItem('searchValues')})
				}
				if(this.$parent.getSelConsumable){
					this.$parent.queryPage.current = 1
					this.$parent.getSelConsumable({page:this.$parent.queryPage.current,row:this.$parent.queryPage.pageSize,title:window.localStorage.getItem('searchValues')})
				}
				if(this.$parent.getAllExamData){
					// this.$parent.queryPage.pageSize = 10000
					// this.$parent.getAllExamData()
					for(var item in this.$parent.$children){
						if(this.$parent.$children[item].getSelExamPaper){
							this.$parent.$children[item].getSelExamPaper()
						}
					
					}
					
				}
				if(this.$parent.getAllTrain){
					for(var item in this.$parent.$children){
						if(this.$parent.$children[item].getOfflineTrainings){
						this.$parent.$children[item].getOfflineTrainings()
						}
					}
				}
				if(this.$parent.getEntry){
					for(var item in this.$parent.$children){
						if(this.$parent.$children[item].getDatas){
							this.$parent.$children[item].getDatas()
						}
						
					}
				}
				
			},
			enterKey(event) {
			     const code = event.keyCode
			         ? event.keyCode
			         : event.which
			             ? event.which
			             : event.charCode;
			     if (code == 13) {
			         this.onSearch();
			     }
			    },
			    enterKeyupDestroyed() {
			        document.removeEventListener("keyup", this.enterKey);
			    },
			    enterKeyup() {
			        document.addEventListener("keyup", this.enterKey);
			    },
		},
		mounted() {
			 this.enterKeyup();
		},
		destroyed() {
		    // 销毁enter事件
		    this.enterKeyupDestroyed();
		},
		created(){
			window.localStorage.setItem('searchValues','')
			console.log(this.title)
		}
	}
</script>

<style scoped>
	.trainContainer {
		width: 100%;
		height: 20rem;
		/* background-image: url(../assets/images/中心概括动物房.png); */
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		z-index: 100;
	}

	.searchBox {
		width: 32.25rem !important;

		background: #FFFFFF;
		border-radius: 0.25rem;
		border: 0 !important;
	}

	
</style>
<style>
	.searchBox .ant-input {
		height: 42px !important;
	}
</style>